/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromptCodeModel } from '../../models/prompt-code-model';

export interface SavePromptCode$Params {
      body?: PromptCodeModel
}

export function SavePromptCode(http: HttpClient, rootUrl: string, params?: SavePromptCode$Params, context?: HttpContext): Observable<StrictHttpResponse<PromptCodeModel>> {
  const rb = new RequestBuilder(rootUrl, SavePromptCode.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PromptCodeModel>;
    })
  );
}

SavePromptCode.PATH = '/api/Supervisor/SavePromptCode';
